import { AxiosError } from 'axios';
import _ from 'lodash';
import { COMMON_ERROR_ALERT_CHANGE_EVENT, DEFAULT_ERROR_MESSAGE } from '../api';
import PubSub from 'pubsub-js';

export const storeDidCatch = (error: AxiosError | Error) => {
  switch (true) {
    case error instanceof AxiosError: {
      const authToken = _.get(error, 'config.headers.Authorization');

      if (!authToken) {
        break;
      }

      PubSub.publish(
        COMMON_ERROR_ALERT_CHANGE_EVENT,
        _.get(error, 'response.data.errors', DEFAULT_ERROR_MESSAGE),
      );
      break;
    }
    case error instanceof Error:
      PubSub.publish(COMMON_ERROR_ALERT_CHANGE_EVENT, DEFAULT_ERROR_MESSAGE);
      break;
  }
};
